module Core {
    export enum VoteStatus {
        EnAttente = 0,
        EnCours = 1,
        Clos = 2
    }
}